module.exports = __webpack_public_path__ + "media/site_templates/www.rangehood-installation.com.au/images/splash-21faa56be9439aef7e3f09072829f262.jpg";